import React from 'react';
import { Box, SvgIcon } from '@agilize/components-core';
import { Description, Title } from './SendSolicitationButton.sytles';

const SendSolicitationButton = () => (
  <Box p={1} data-testid="send-solicitation-button" display="flex" alignItems="center">
    <SvgIcon src={`${process.env.APP_PATH}public/assets/icons/envelope-question.svg`} />
    <Box ml={2}>
      <Title>Envie uma solicitação</Title>
      <Description>Respondemos em até 48 horas</Description>
    </Box>
  </Box>
);

export default SendSolicitationButton;
